import React          from 'react';
import classnames     from 'classnames';
import renderHTML from 'react-render-html';

const QuoteTips = props => (
  <div className="tips">
    <span className="main-title">Tips</span>
    {props.list.map((item, idx) => (
      <QuoteTipItem key={idx} title={item.title} lines={item.lines} />
    ))}
    {props.children}
  </div>
);

QuoteTips.defaultProps = [];

const QuoteTipItem = props => (
  <div className="tip-item">
    <div className="title">{props.title}</div>
    <ul className={classnames({ 'list-unstyled': props.title !== '' })}>
      {props.lines.map((line, idx) => (
        <li key={idx}>{ renderHTML(line) }</li>
      ))}
    </ul>
  </div>
);

export default QuoteTips;
